(function () {
    'use strict';

    angular
        .module('completeAir')

        .factory('complementAirCrewService', complementAirCrewService);

    complementAirCrewService.$inject = ['$http', 'CONFIG', 'messageService'];


    function complementAirCrewService($http, CONFIG, messageService) {
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/crew/';

        var occupationAirCrewList = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/occupationCrews/list?commandCrew=';

        var service = {
            getComplementAirCrews: getComplementAirCrews,
            getPageComplementAirCrews: getPageComplementAirCrews,
            getComplementAirCrewById: getComplementAirCrewById,
            saveComplementAirCrew: saveComplementAirCrew,
            saveAddComplementAirCrew: saveAddComplementAirCrew,
            updateComplementAirCrew: updateComplementAirCrew,
            deleteComplementAirCrew: deleteComplementAirCrew,
            getOccupationCrewListComplement: getOccupationCrewListComplement,
            getOccupationCrewListCommando: getOccupationCrewListCommando

        };
        return service;

        function getComplementAirCrews() {
            return $http.get(urlBase + "?commandCrew=false&active=true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.aircrews : [];
            }

            function getFailed() {
                messageService.findAllError('complementAirCrews');
            }
        }

        function getPageComplementAirCrews(page, size){
            return $http.get(urlBase + 'page?page=' + page + '&size=' + size + '&commandCrew=false&active=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('complementAirCrews')
                });
        }

        function saveComplementAirCrew(occupationCrew) {
            return $http.post(urlBase + "?commandCrew=false&active=true", occupationCrew)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete() {
                messageService.register('complementAirCrews');
            }

            function getFailed() {
                messageService.registerError('complementAirCrews');
            }
        }

        function saveAddComplementAirCrew(occupationCrew) {
            return $http.post(urlBase + "?commandCrew=false&active=true", occupationCrew)
                .then(function (response) {
                    messageService.register('');
                    return response;
                })
                .catch(function() {
                    messageService.registerError('');
                });
        }

        function getComplementAirCrewById(id) {
            return $http.get(urlBase + id)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data) ? response.data : [];
            }

            function getFailed() {
                messageService.findAllError('complementAirCrews');
            }
        }

        function updateComplementAirCrew(id, occupationCrew) {
            return $http.put(urlBase + id, occupationCrew)
                .then(function (response) {
                    messageService.registerUpdate('complementAirCrews')
                    return response;
                })
                .catch(function (error) {
                    messageService.findAllError('complementAirCrews');
                });
        }

        function deleteComplementAirCrew(id) {
            return $http.delete(urlBase + id)
                .then(deleteComplete)
                .catch(getFailed);

            function deleteComplete() {
                messageService.register('complementAirCrews');
            }

            function getFailed() {
                messageService.registerError('complementAirCrews');
            }
        }

        function getOccupationCrewListComplement() {
            return $http.get(occupationAirCrewList + "false")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data) ? response.data : [];
            }

            function getFailed() {
                messageService.findAllError('complementAirCrews');
            }
        }

        function getOccupationCrewListCommando() {
            return $http.get(occupationAirCrewList + "true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data) ? response.data : [];
            }

            function getFailed() {
                messageService.findAllError('complementAirCrews');
            }
        }
    }

})();

